"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfficeApiResponseSchema = void 0;
const zod_1 = require("zod");
const doctor_attending_1 = require("../doctor-attendings/doctor-attending");
const address_schema_1 = require("../global/address.schema");
const api_1 = require("../global/api");
const profile_schema_1 = require("../global/profile.schema");
const getOfficeDoctorItemRelationApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-attendings'),
    attributes: zod_1.z.object({
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        phoneNumber: zod_1.z.string().nullable().default(null),
        orderRegistrationNumber: zod_1.z.string(),
        rhythm: zod_1.z.string().nullable().default(null),
        iban: zod_1.z.string().nullable().default(null),
        bic: zod_1.z.string().nullable().default(null),
        signatureUrl: profile_schema_1.signatureUrlSchema,
        workSchedulesDateRef: zod_1.z.string().nullable(),
        workSchedules: doctor_attending_1.workSchedulesSchema,
        createdAt: zod_1.z.coerce.date(),
        /** Set once the doctor left the company; such doctors stay listed for history. */
        deactivatedAt: zod_1.z.coerce.date().nullable().default(null),
    }),
});
exports.getOfficeApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('offices'),
        attributes: zod_1.z.object({
            name: zod_1.z.string(),
            nationalMedicalOrderMail: zod_1.z.string(),
            address: address_schema_1.addressSchema,
            estimatedCaPerSlot: zod_1.z.coerce.number(),
            averageSlotHonorary: zod_1.z.coerce.number(),
            withAssistantRetrocessionRate: zod_1.z.number(),
            withoutAssistantRetrocessionRate: zod_1.z.number(),
            weekendRetrocessionRate: zod_1.z.number(),
            createdAt: zod_1.z.coerce.date(),
            siteId: zod_1.z.string().uuid(),
            /**
             * Whether the practice is already open. Display-only: drives the
             * recruitment page's "· bientôt" chip and nothing else.
             */
            open: zod_1.z.boolean().default(true),
            assignedCsm: zod_1.z
                .object({
                id: zod_1.z.string().uuid(),
                firstname: zod_1.z.string(),
                lastname: zod_1.z.string(),
            })
                .nullable(),
            /**
             * Set when the practice closed: every read still works, writes are
             * refused with a 409 and the office leaves the substitute-facing lists.
             */
            deactivatedAt: zod_1.z.coerce.date().nullable().default(null),
        }),
        relationships: zod_1.z.object({
            doctors: (0, api_1.apiEntityRelationshipsSchema)('doctor-attendings').optional(),
        }),
    }),
    included: zod_1.z
        .array(getOfficeDoctorItemRelationApiResponseSchema)
        .optional()
        .default([]),
});
